import { Circle, Minus, Square, Star, Triangle } from 'lucide-react';
import React, { FC } from 'react';

import { createShapeElement } from '../../../model/factories';
import { useAdsGeneratorStore } from '../../../model/store';
import { ShapeKind } from '../../../model/types';
import { PanelSection } from '../../common';
import { OptionCard, OptionGrid } from '../Editor.styled';

const SHAPES: { kind: ShapeKind; label: string; icon: typeof Square }[] = [
  { kind: 'rect', label: 'Prostokąt', icon: Square },
  { kind: 'ellipse', label: 'Elipsa', icon: Circle },
  { kind: 'triangle', label: 'Trójkąt', icon: Triangle },
  { kind: 'star', label: 'Gwiazda', icon: Star },
  { kind: 'line', label: 'Linia', icon: Minus },
];

export const ShapesPanel: FC = () => {
  const scene = useAdsGeneratorStore((state) => state.scene);
  const addElement = useAdsGeneratorStore((state) => state.addElement);

  if (!scene) return null;

  return (
    <PanelSection title="Kształty">
      <OptionGrid>
        {SHAPES.map(({ kind, label, icon: Icon }) => (
          <OptionCard
            key={kind}
            type="button"
            onClick={() => addElement(createShapeElement(kind, scene.width, scene.height))}
          >
            <Icon size={18} />
            {label}
          </OptionCard>
        ))}
      </OptionGrid>
    </PanelSection>
  );
};
